import React from "react";

// Components imports
import Button from "../../common/Button";

// Icons imports
import { HiArrowNarrowLeft } from "react-icons/hi";
import { HiArrowNarrowRight } from "react-icons/hi";

// Scss imports
import css from "./PrevNextButtonsContainer.module.scss";

interface PrevNextButtonsContainerProps {
  prevButtonClickHandler: Function;
  nextButtonClickHandler: Function;
  refPrevButton: any;
  refNextButton: any;
  disabledPrevButton?: boolean;
  disabledNextButton?: boolean;
  hiddenPrev?: boolean;
  hiddenNext?: boolean;
}

const PrevNextButtonsContainer: React.FC<PrevNextButtonsContainerProps> = ({
  prevButtonClickHandler,
  nextButtonClickHandler,
  refPrevButton,
  refNextButton,
  disabledPrevButton,
  disabledNextButton,
  hiddenPrev,
  hiddenNext
}) => {
  return (
    <div className={css.container}>
      <Button
        icon={<HiArrowNarrowLeft color="#982d8f" fontSize="2.3rem" />}
        onButtonClickHandler={prevButtonClickHandler}
        style={{ borderRadius: "5rem", marginTop: "5rem" }}
        refButton={refPrevButton}
        disabledButton={disabledPrevButton}
        hidden={hiddenPrev}
      />

      <Button
        icon={<HiArrowNarrowRight color="#982d8f" fontSize="2.3rem" />}
        onButtonClickHandler={nextButtonClickHandler}
        style={{ borderRadius: "5rem", marginTop: "5rem" }}
        refButton={refNextButton}
        disabledButton={disabledNextButton}
        hidden={hiddenNext}
      />
    </div>
  );
};

export default PrevNextButtonsContainer;
